import React from "react";
import styled from "@emotion/styled";

import LogoImg from "../../assets/images/sonkthai-Logo.png";
import WinkL from "../../assets/images/wink-L.png";
import WinkM from "../../assets/images/wink-M.png";
import WinkS from "../../assets/images/wink-S.png";
import ShareIcon from "../../assets/icons/share.svg";

const ShareFB = ({ personalId, week, reward = {} }) => {
  return (
    <Body>
      <MainContainer id="rewardShareFB">
        <Wink1 src={WinkL} />
        <Wink2 src={WinkM} />
        <Wink3 src={WinkS} />
        <RewardImg
          src={
            reward.image &&
            require(`../../assets/images/badges/${reward.image}`)
          }
        />
        <Wink4 src={WinkL} />
        <Wink5 src={WinkM} />
        <Wink6 src={WinkS} />
        <Container>
          <Conclusion>ขอมอบ{reward.desc}</Conclusion>
          <Remark>
            <Info>
              เลขประจำตัว {personalId} &nbsp;&nbsp; ท่านถึงเป้าหมาย{" "}
              {reward.category}
            </Info>
            สัปดาห์ที่ {week} &nbsp;&nbsp; {reward.levelInfo}
          </Remark>
          <SonkthaiImg src={LogoImg} />
        </Container>
      </MainContainer>
    </Body>
  );
};

export default ShareFB;

const Body = styled.div`
  position: absolute;
  z-index: -1;
  top: -1000vh;
`;

const MainContainer = styled.div`
  width: 1044px;
  padding-top: 37px;
  background: linear-gradient(
      179.7deg,
      rgba(255, 219, 165, 0.6) -2.19%,
      rgba(249, 249, 249, 0.6) 48.23%
    ),
    #ffffff;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  position: relative;
`;
const Container = styled.div`
  font-family: Noto Sans Thai, Noto Sans;
  background: #fff;
  padding-top: 170px;
  margin-top: -176px;
  border-top-left-radius: 50% 60px;
  border-top-right-radius: 50% 60px;
  padding-bottom: 37px;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
`;
const Info = styled.h5`
  font-weight: 700;
  font-size: 28px;
  line-height: 34px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #64748b;
  margin-bottom: 51px;
`;
const Remark = styled.div`
  font-weight: 400;
  font-size: 24px;
  line-height: 26px;
  text-align: center;
  color: #64748b;
  margin-bottom: 16px;
  margin-top: 17px;
`;
const RewardImg = styled.img`
  margin-bottom: 27px;
  width: 308.99px;
  margin-left: auto;
  margin-right: auto;
  display: block;
`;
const SonkthaiImg = styled.img`
  height: 68.47px;
  width: 143px;
  position: absolute;
  bottom: 30px;
  right: 35px;
`;
const Conclusion = styled.div`
  font-weight: 700;
  font-size: 34px;
  line-height: 40px;
  text-align: center;
  letter-spacing: -0.04em;
  color: #16af7b;
`;
const Wink1 = styled.img`
  position: absolute;
  top: 68px;
  left: 376px;
  width: 24px;
  height: 24px;
`;
const Wink2 = styled.img`
  position: absolute;
  top: 90px;
  left: 355px;
  width: 11px;
  height: 11px;
`;
const Wink3 = styled.img`
  position: absolute;
  top: 45px;
  left: 378px;
  width: 6px;
  height: 6px;
`;
const Wink4 = styled.img`
  position: absolute;
  top: 87px;
  right: 385px;
  width: 19px;
  height: 19px;
`;
const Wink5 = styled.img`
  position: absolute;
  top: 71px;
  right: 365px;
  width: 11px;
  height: 11px;
`;
const Wink6 = styled.img`
  position: absolute;
  top: 115px;
  right: 377px;
  width: 5px;
  height: 5px;
`;
